import { AGGWTransport, AGTransport, } from "@agrigate/shared/lib/rpc/clients";
import { ensureNN } from "@agrigate/ts-utils/lib/coercions";
import { thruUnlessN } from "@agrigate/ts-utils/lib/nullability";
import { rpcClient } from "@lorefnon/ts-json-rpc/lib/client";
export const getClients = (opts, interceptors) => {
    console.debug("RPC client opts:", opts);
    const transports = {
        backend: thruUnlessN(opts.backend, _ => new AGTransport(_)),
        gateway: thruUnlessN(opts.gateway, _ => new AGGWTransport(_)),
    };
    const clientOpts = (name, entryPoint = "backend") => {
        if (transports[entryPoint]) {
            return {
                transport: ensureNN(transports[entryPoint], "service entry point"),
                meta: { name },
                onError: interceptors?.onError,
                onStart: interceptors?.onStart,
                onEnd: interceptors?.onEnd,
                onSuccess: interceptors?.onSuccess,
            };
        }
        throw new Error("RPC client: Invalid Service Type Registration");
    };
    const client = (name, service = "backend") => rpcClient(clientOpts(name, service));
    const gwClient = (gatewayName, backendName) => opts.useGateway === false
        ? client(backendName)
        : client(gatewayName, "gateway");
    return {
        client,
        translations: client("translations"),
        location: client("location"),
        userProfile: client("user-profile"),
        users: client("users"),
        empGeoScopes: client("emp-geo-scopes"),
        // methods.ts not found
        aadhaarVerification: client("aadhaar-verification"),
        alerts: client("alerts"),
        auth: client("auth"),
        produceTypes: client("produce-types"),
        produceTypeCategories: client("produce-type-categories"),
        produceBatches: client("produce-batches"),
        payouts: client("payouts"),
        buyerOrders: client("buyer-orders"),
        purchaseOrders: client("purchase-orders"),
        profileTypes: client("profile-types"),
        notification: client("notification"),
        settings: client("settings"),
        customerSupport: gwClient("customer-support/core", "customer-support"),
        feed: {
            /* core: client<FeedService>("feed"),
            engagement: client<FeedEngagementService>("feed-engagement"), */
            core: gwClient("feed/core", "feed"),
            engagement: gwClient("feed/engagement", "feed-engagement"),
            notifyer: client("feed-notifyer"),
            categories: client("feed-categories"),
            visitors: client("feed-visitors"),
        },
        earnings: client("earnings"),
        invoices: client("invoices"),
        // methods.ts not found
        transactionImport: client("transaction-import"),
        deliveryTracks: client("delivery-tracks"),
        deliveryTrackStops: client("delivery-track-stop"),
        contentSync: client("content-sync"),
        bankAccounts: client("bank-accounts"),
        payoutAccounts: client("payout-accounts"),
        trustedUsers: client("trusted-users"),
        // methods.ts not found
        reporting: client("reporting"),
        // methods.ts not found
        stash: client("stash"),
        // methods.ts not found
        notificationPreferences: client("notification-preferences"),
        transactions: client("transactions"),
        userFeatures: client("user-feature"),
        cache: client("cache"),
        extIdSeq: client("ext-id-seq"),
        shipments: client("shipments"),
        // methods.ts not found
        inventory: client("inventory"),
        collectionTargets: client("collection-targets"),
        cpBalance: client("cp-balance"),
        cpSchedule: client("cp-schedule"),
        reimbursementRequest: client("reimbursement-request"),
        // methods.ts not found
        internalMailer: client("internal-mailer"),
        // methods.ts not found
        priceTracker: client("price-tracker"),
        // methods.ts not found
        employeeTracking: client("employee-track"),
        apiKeys: client("api-keys"),
        // methods.ts not found
        demandSpeculations: client("demand-speculations"),
        collectionCenter: client("collection-center"),
        cpCommissions: client("cp-commissions"),
        cpIncentiveConfig: client("cp-incentive-config"),
        channelPartners: client("channel-partner"),
        notificationTemplate: client("notification-template"),
        superpower: client("superpower"),
        pg: client("pg"),
        // methods.ts not found
        zoho: client("zoho-sync"),
        zohoUserSync: client("zoho-user-sync"),
        zohoPayments: client("zoho-payments"),
        evtInterest: client("event-interest"),
        surveys: gwClient("survey/surveys", "surveys"),
        rewards: client("rewards"),
        rewardTransactions: client("reward-transactions"),
        rewardSources: client("reward-sources"),
        rewardRedemptions: client("reward-redemptions"),
        reputationTiers: client("reputation-tiers"),
        reputation: client("reputation"),
        cluster: client("cluster"),
        weather: gwClient("weather", "weather"),
        insurance: {
            plans: gwClient("insurance/plans", "insurance-plans"),
            policies: gwClient("insurance/policies", "insurance-policies"),
            providers: gwClient("insurance/providers", "insurance-providers"),
            applications: gwClient("insurance/applications", "insurance-applications"),
            categories: gwClient("insurance/categories", "insurance-categories"),
            claim: gwClient("insurance/claims", "insurance-claims"),
            banners: gwClient("insurance/banners", "insurance-banners"),
        },
        marketplace: {
            product: gwClient("marketplace/product", "marketplace-product"),
            sku: gwClient("marketplace/sku", "marketplace-sku"),
            order: gwClient("marketplace/order", "marketplace-order"),
            batchOrder: gwClient("marketplace/batch-order", "marketplace-batch-order"),
            brand: gwClient("marketplace/brand", "marketplace-brand"),
            productCategory: gwClient("marketplace/product-category", "marketplace-product-category"),
            banner: gwClient("marketplace/banner", "marketplace-banner"),
            pricingConfig: gwClient("marketplace/pricing-config", "marketplace-pricing-config"),
            inventory: gwClient("marketplace/inventory", "marketplace-inventory"),
            shipment: client("marketplace-shipment"),
        },
        actions: client("actions"),
        resourceAccess: client("resource-access"),
        equipment: {
            categories: gwClient("equipment/categories", "equipment-categories"),
            // brands: gwClient<EquipmentBrandsService>("equipment/brands", "equipment-brands"),
            machines: gwClient("equipment/machines", "equipment-machines"),
            models: gwClient("equipment/models", "equipment-models"),
            booking: gwClient("equipment/booking", "equipment-booking"),
            pricing: gwClient("equipment/pricing", "equipment-pricing"),
            plot: gwClient("equipment/plot", "equipment-plot"),
            serviceSession: gwClient("equipment/service-session", "equipment-service-session"),
            payments: gwClient("equipment/payments", "equipment-payments"),
        },
        docApproval: client("doc-approval"),
        // methods.ts not found
        dBankSearchResults: gwClient("feed/search-results", "search-results"),
        // methods.ts not found
        dBankSearchTopics: gwClient("feed/search-topics", "search-topics"),
        // methods.ts not found
        dBankSearchEngines: gwClient("feed/search-engines", "search-engines"),
        // methods.ts not found
        dBankSuggestedTopics: gwClient("feed/suggested-topics", "suggested-topics"),
        soilTestingTests: gwClient("soil-testing/tests", "tests"),
        soilTestingBrands: gwClient("soil-testing/brands", "soil-testing-brands"),
        soilTestingBooking: gwClient("soil-testing/booking", "booking"),
        soilTestingReports: gwClient("soil-testing/reports", "reports"),
        soilTestingPricingConfig: gwClient("soil-testing/pricing-config", "soil-testing-pricing-config"),
        discounts: client("discounts"),
        reports: {
            orderAggrs: gwClient("reporting-api/order-aggregates", "order-aggregates"),
            userAggrs: gwClient("reporting-api/user-aggregates", "user-aggregates"),
            shipmentAggrs: gwClient("reporting-api/shipment-aggregates", "shipment-aggregates"),
            clusterAggrs: gwClient("reporting-api/cluster-aggregates", "cluster-aggregates"),
            filters: gwClient("filters", "filters"),
            bgJobs: gwClient("reporting-api/background-jobs", "background-jobs"),
            dashMetrics: gwClient("reporting-api/dashboard-metric", "dashboard-metric"),
            insuranceAggrs: gwClient("reporting-api/insurance-aggregates", "insurance-aggregates"),
            bookingAggrs: gwClient("reporting-api/booking-aggregates", "booking-aggregates"),
            marketplaceAggrs: gwClient("reporting-api/marketplace-aggregates", "marketplace-aggregates"),
            soilTestingAggrs: gwClient("reporting-api/soil-testing-aggregates", "soil-testing-aggregates"),
            aiTokenAggrs: gwClient("reporting-api/ai-token-usage", "ai-token-usage"),
            investorReports: gwClient("reporting-api/investor-reports", "investor-reports"),
            aggregator: gwClient("reporting-api/aggregator", "aggregator"),
            metrics: gwClient("reporting-api/reporting-metrics", "reporting-metrics-rpc"),
        },
    };
};
//# sourceMappingURL=index.js.map